import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'
import Button from '../../../UniformComponents/Button'

const CreateEmailListModal = ({ distributeStore }) => (
    <Modal
        show={distributeStore.createEmailListModalVisisble}
        onClose={distributeStore.hideCreateEmailListModal}
    >
        <Typography type="h3">{i18n.t('sch_email_list_add')}</Typography>

        <br />
        {distributeStore.importProcessing
            ? (
                <div style={{ textAlign: 'center' }}>
                    <Typography type="h4">{i18n.t('distributionEmailList.uploadingTitle')}</Typography>

                    <Typography type="tiny">{i18n.t('distributionEmailList.uploadingSubText1')}</Typography>

                    <Typography type="tiny">{i18n.t('distributionEmailList.uploadingSubText2')}</Typography>
                </div>
            )
            : (
                <div className="create-email-list-upload">
                    <div className="upload-icon-container ">
                        <i className="far fa-upload" />
                    </div>

                    <br />

                    <Typography type="b">{i18n.t('sch_upload_email')}</Typography>

                    <Typography>{i18n.t('distributionEmailList.emptyStateSubText')}</Typography>

                    <br />

                    <input
                        type="file"
                        accept=".csv"
                        onChange={distributeStore.uploadListFile}
                        ref={(input) => { distributeStore.uploadEl = input }}
                        style={{ display: 'none' }}
                    />

                    <Button
                        label={i18n.t('distributionEmailList.upload')}
                        icon="far fa-upload"
                        cssClass="regular primary"
                        onClick={distributeStore.createEmailListModalContinue}
                    />
                </div>
            )}
    </Modal>
)

export default observer(CreateEmailListModal)
